import { InfoOutlined } from '@mui/icons-material'
import {
  Box,
  Card,
  CardContent,
  Tooltip,
  Typography,
} from '@mui/material'

import type { UserStats } from './analytics-utils'

type StatCardProps = {
  label: string
  value: number
  color?: string
  description?: string
}

export function StatCard({ label, value, color, description }: StatCardProps) {
  return (
    <Card sx={{ flex: '1 1 0', minWidth: 150 }}>
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
          <Typography variant="body2" color="text.secondary" fontWeight={500}>
            {label}
          </Typography>
          {description && (
            <Tooltip title={description} arrow placement="top">
              <InfoOutlined sx={{ fontSize: 14, color: 'text.disabled', cursor: 'help' }} />
            </Tooltip>
          )}
        </Box>
        <Typography variant="h4" fontWeight="bold" sx={{ color, letterSpacing: '-0.02em' }}>
          {value}
        </Typography>
      </CardContent>
    </Card>
  )
}

type BreakdownSectionProps = {
  title: string
  stats: UserStats
}

export function BreakdownSection({ title, stats }: BreakdownSectionProps) {
  return (
    <Card sx={{ flex: '1 1 0', minWidth: 300 }}>
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
        <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
          {title} ({stats.total})
        </Typography>
        <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
          <Box>
            <Typography variant="body2" color="text.secondary">Verified + Purchased</Typography>
            <Typography variant="h5" fontWeight="bold" sx={{ color: 'success.main' }}>{stats.verifiedPurchased}</Typography>
          </Box>
          <Box>
            <Typography variant="body2" color="text.secondary">Verified + No Purchase</Typography>
            <Typography variant="h5" fontWeight="bold" sx={{ color: 'success.light' }}>{stats.verifiedNotPurchased}</Typography>
          </Box>
          <Box>
            <Typography variant="body2" color="text.secondary">Unverified + Purchased</Typography>
            <Typography variant="h5" fontWeight="bold" sx={{ color: 'warning.main' }}>{stats.unverifiedPurchased}</Typography>
          </Box>
          <Box>
            <Typography variant="body2" color="text.secondary">Unverified + No Purchase</Typography>
            <Typography variant="h5" fontWeight="bold" sx={{ color: 'text.secondary' }}>{stats.unverifiedNotPurchased}</Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}
